import { render, staticRenderFns } from "./DashboardKpis.vue?vue&type=template&id=6d5d5494&scoped=true"
import script from "./DashboardKpis.vue?vue&type=script&lang=js"
export * from "./DashboardKpis.vue?vue&type=script&lang=js"
import style0 from "./DashboardKpis.vue?vue&type=style&index=0&id=6d5d5494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d5494",
  null
  
)

export default component.exports